import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectCoinPrices = createSelector(
	(state: IStore) => state.coinPrices,
	(coinPrices) => coinPrices
)
